import type { SpecialIndexVariant } from ".";

export const WithCustomQueryVariant: SpecialIndexVariant[] = ["series", "spotlight"];
